import React from 'react'

export const Contact = () => {
    return (
        <div>
            <h1>Estamos en contact</h1>
        </div>
    )
}
